module.exports = __webpack_public_path__ + "d4059d927ff42a1eea6e139b1bc675a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-9.png
// module id = 3021
// module chunks = 0